import { Range } from 'react-date-range';
import { BsFiletypeCsv } from 'react-icons/bs';
import { FiDownload } from 'react-icons/fi';

import { formatDateToBR } from 'helpers';
import { useAuth } from 'hooks';
import { reportsTransactionsService } from 'services';

interface ReportInfoProps {
  dateRange: Range;
}

export function ReportInfo(props: ReportInfoProps) {
  const { dateRange } = props;
  const { startDate, endDate } = dateRange;
  const { selectedStore } = useAuth();
  const store = selectedStore.name || '';

  async function handleDownloadReport() {
    try {
      await reportsTransactionsService.downloadReport(store);
    } catch (error) {
      console.error('Error downloading report:', error);
    }
  }

  return (
    <div className="flex w-full gap-4 p-4 rounded-lg bg-neutral-200">
      <BsFiletypeCsv className="w-12 h-12" />
      <div className="flex flex-grow justify-between items-center gap-4">
        <div className="flex flex-col gap-1.5 max-w-[872px]">
          <p className="text-sm font-bold text-neutral-500">
            Seu último relatório gerado está aqui
          </p>
          <p className="text-xs text-neutral-500">
            Consulta de{' '}
            <span className="font-bold">
              {formatDateToBR(startDate)} a {formatDateToBR(endDate)}
            </span>
          </p>
        </div>
        <button
          className="flex items-center gap-2 px-4 py-2.5 text-primary-300 text-sm font-medium
            hover:underline"
          onClick={handleDownloadReport}
        >
          <FiDownload className="w-5 h-5" />
          <span>Baixar relatório</span>
        </button>
      </div>
    </div>
  );
}
